import { render, staticRenderFns } from "./CouponAddButton.vue?vue&type=template&id=1485b04b&scoped=true&"
import script from "./CouponAddButton.vue?vue&type=script&lang=js&"
export * from "./CouponAddButton.vue?vue&type=script&lang=js&"
import style0 from "./CouponAddButton.vue?vue&type=style&index=0&id=1485b04b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1485b04b",
  null
  
)

export default component.exports